@if(data){<div class="color-picker-popup" >
     <!-- <span class="material-icons close-btn top-1 right-1" (click)="closePopup()">close</span> -->
    <div class="text-[20px] font-bold">
        Brand Terms Agreement ({{data?.version}})
    </div>

    <div [innerHtml]="data?.description" class="mt-8 overflow-auto max-h-120">

    </div>
    
     <div class="flex justify-center items-center flex-wrap gap-4 mt-8">
        <button mat-flat-button class="btn-theme-color !min-w-[90px] p-2 rounded" (click)="accept()" 
            type="button">
            Review and accept Seller Terms
        </button>
        <button mat-flat-button class="btn-white border !min-w-[90px] p-2 rounded"  (click)="closePopup()"
            type="button">
            I'll review it later
        </button>
    </div>
    
</div>}